import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";

export function humanizeAuditAction(action: string): string {
  const lower = action.replace(/_/g, " ").toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function formatAuditDateTime(value: string): string {
  return format(parseISO(value), "dd MMM yyyy HH:mm", { locale: fr });
}

export function getAuditPageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

export function hasAuditMetadata(metadata: Record<string, unknown> | null): boolean {
  return Boolean(metadata && Object.keys(metadata).length > 0);
}
